<template>
    <div id="drug-order-items-relocation-container">
        <b-row>
            <b-col sm="12">
                <MdTitle v-bind:Text="$t('DrugOrderItemsRelocation.Title')" />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugOrderItemsRelocation.DateReceivedFrom')"
                    v-bind:Name="'dateReceivedFrom'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="parameters.dateReceivedFrom"
                /> 
            </b-col>  
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugOrderItemsRelocation.DateReceivedTo')"
                    v-bind:Name="'dateReceivedTo'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="parameters.dateReceivedTo"
                /> 
            </b-col>  
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugOrderItemsRelocation.ExpirationDateFrom')"
                    v-bind:Name="'expirationDateFrom'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="parameters.expirationDateFrom"
                /> 
            </b-col>  
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugOrderItemsRelocation.ExpirationDateTo')"
                    v-bind:Name="'expirationDateTo'"
                    v-bind:TypeProp="'date'" 
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="parameters.expirationDateTo"
                /> 
            </b-col>  
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdLookupMultiple
                    v-bind:ModelCode="parameters.drugCode"
                    v-bind:ModelDescription="parameters.drugName"
                    v-bind:Label="$t('Medication.Drugs')"                             
                    v-bind:RefCode="'Drugs'"  
                    v-bind:Api="DrupNameCall"
                    v-bind:OptionParamList="ParamList"                                                   
                    v-bind:FieldCode="'code'"   
                    v-bind:modelFilter="modelFilter"                         
                    v-bind:FieldDescription="'drugName'"
                    :ChangeFilter="ChangeFilter"                         
                    :SearchTitle="$t('Medication.Drugs')"
                    :GetValues="onCodeConditionOk"                     
                    :SearchFieldCode="'Code'"
                    v-bind:Fields="BaseFieldsDrug"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugOrderItemsRelocation.LotNo')"
                    v-bind:Name="'Lot-number'"
                    v-bind:TypeProp="'text'" 
                    v-bind:OnPressEnter="SearchItems"        
                    v-model="parameters.lotNo"
                    v-bind:Id="'lot-number'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('DrugOrderItemsRelocation.LocationFrom')"
                    v-bind:Options="pharmacyLocations"
                    v-bind:ModelArray="pharmacyVModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    :Input="changeDropDownPharmacy"/>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="mt-3 text-right">
                    <button 
                        v-on:click="SearchItems"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput">
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>

        <MdTitle v-bind:Text="viewText" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="parameters.PageNumber"
                    v-bind:perPage="parameters.PageSize"
                    v-bind:pageOptions="pageOptions"
                    :editIconEvent="editHandler"
                    v-bind:VisibleEditIcon="true"
                    v-bind:IsItemRelocation="true"
                    v-bind:VisibleDeleteIcon="false"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"   
                >                
                </MdTable>              
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Report')"
                v-bind:Name="'btnReport'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="ShowReport()"
            />
        </div>

        <DrugOrderItemsRelocationEditDlg
            v-bind:visible="visibleEditDialog"
            v-model="editableItem"
            @close="closeHandler"
            @ok="okHandler"
            :locations="getLocationFilter(editableItem.location)"
        >
        </DrugOrderItemsRelocationEditDlg>

        <ItemsRelocationRep v-if="isItemReloReportVisible" 
          :closeWindow="closeItemReloReportWindow"
          :winTitle="$t('employee.ItemsRelocation')"
          :ReportName="'ItemRelocation'"
          :isRelocation=true
        />
    </div>
</template>

<script>
import ePharmacyItemsLocationService from '@/services/epharmacylocation.service'
import ePharmacyItemsReceivedService from '@/services/epharmacyitemsreceived.service'
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js';
import Utils from "@/common/utils";
import DrugOrderItemsRelocationEditDlg from './DrugOrderItemsRelocationEditDlg'

export default {
    name: 'DrugOrderItemsRelocation',
    mixins: [DBFunctions, ShowMessage],
    components: {
        DrugOrderItemsRelocationEditDlg
    },

    data() {
        return {
            OptionsRightMenu:{
                visible:false,
                btnvisible:false,
                ItemsList:[],
                favButtonAtion: false
            },
            parameters: {
                dateReceivedFrom: null,
                dateReceivedTo: null,
                expirationDateFrom: null,
                expirationDateTo: null,
                lotNo: null,
                drugCode: null,
                drugName: null,
                pharmacyLocation: '',
                PageSize: 10,
                PageNumber: 1
            },
            BaseFieldsDrug:[
                { key: 'drugName', sortable: true, label: this.$t('Medication.DrugName')},
                { key: 'activeIngredients', sortable: true, label: this.$t('Medication.AcIngredients')},
                { key: 'dosage', sortable: true, label: this.$t('Medication.Dosage')},
                { key: 'form', sortable: true, label: this.$t('Medication.Form')},
                { key: 'code', sortable: true, label: this.$t('Shared.Code')}
            ],
            ParamList:[
                {
                    code:1,
                    description:this.$t('Medication.Param.AllDrugs'),
                    resource:"PatientMedications/AllDrugs?"
                },
                {
                    code:2,
                    description:this.$t('Medication.Param.DrugsHistory'),
                    resource:"PatientMedications/DrugsHistory?PatientCode="+this.$route.params.id
                },
                {
                    code:3,
                    description:this.$t('Medication.Param.DrugByDiag'),
                    resource:"PatientMedications/DrugsByDiagnoses?PatientCode="+this.$route.params.id
                },
                {
                    code:4,
                    description:this.$t('Medication.Param.PrefDrugs'),
                    resource:"PatientMedications/PreferredDrugs?"
                },
            ],

             fields:[
                { key: 'drugName', label: this.$tc('DrugOrderItemsRemoval.DrugName',1) },         
                { key: 'activeIngred', label: this.$t('DrugOrderItemsRemoval.Ingredient') },
                { key: 'expirationDateItemRelocation', label: this.$t('DrugOrderItemsRemoval.ExpirationDate'), formatter: (value) => {return Utils.formatterDateToString(value);} },
                { key: 'lotNo', label: this.$t('DrugOrderItemsRemoval.LotNo') },  
                { key: 'locationDescription', label: this.$t('DrugOrderItemsRemoval.Location')},
                { key: 'qtyFilled', label: this.$t('DrugOrderItemsRemoval.Filled') },
                { key: 'qtyReceived',label: this.$t('DrugOrderItemsRemoval.Received') },
                { key: 'qtyAvailable', label: this.$t('DrugOrderItemsRemoval.Available') },
            ],

            modelFilter:{code:1,description:this.$t('Medication.Param.AllDrugs'),resource:"PatientMedications/AllDrugs?"},
            DrupNameCall:"PatientMedications/AllDrugs?",
            pharmacyLocations: [],
            pharmacyVModel: null,
            pharmacyToVModel: null,
            pharmacyLocationTo: null,
            pharmacyLocationValid: true,

            items: [],
            showMessageIsEmpty: false,
            totalRows: 0,
            isReadOnly: false,
            pageOptions: [5, 10, 15 ],
            visibleEditDialog: false,
            isItemReloReportVisible: false,
            editableItem: {
                drugName: '',
                activeIngred: '',
                expirationDate:'',
                lotNo:'',
                location: '',
                qtyFilled:'',
                qtyReceived:'',
                qtyAvailable:'',
                qtyToMove: null,
                notes:null,
                locationTo:null,
                itemCode:null,
                requisitionNumber:null
            },
            editableIndex: -1,
            viewText: `${this.$t('Shared.SearchResult')} - ` +
                `${this.$t('DrugOrderItemsRemoval.Filled')}: 0 - ` +
                `${this.$t('DrugOrderItemsRemoval.Received')}: 0 - ` +
                `${this.$t('DrugOrderItemsRemoval.Available')}: 0`
        }
    },
    methods: {

        getLocationFilter(location){        

            return this.pharmacyLocations.filter(item => item.code !== location);
        },

        goProcess() {
            const data = {
                location: this.editableItem.locationTo,
                Relocations: [
                    {
                        itemNo: this.editableItem.itemNo,
                        batchNo: this.editableItem.batchNo,
                        itemCode: this.editableItem.itemCode,
                        qtyToMove: this.editableItem.qtyToMove,
                        requisitionNumber: this.editableItem.requisitionNumber,
                        notes: this.editableItem.notes,
                    }
                ]
            };

            ePharmacyItemsReceivedService
                .processRelocation(data)
                .then((response) => {
                    if(response.status == '200'){
                        this.pendingChanges = false;
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                            , 50
                        ); 

                        this.SearchItems();
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        onCodeConditionOk(result) {
            var type = result.FieldName;
            if(type.indexOf('Drugs')  >= 0 ) {
                this.parameters.drugCode = result.code.trim();
                this.parameters.drugName = result.description.trim();
            }
        },

        changeDropDownPharmacy(status) {
            this.parameters.pharmacyLocation = status ? status.code : '';
        },

        changeDropDownPharmacyTo(status) {
            this.pharmacyLocationTo = status ? status.code : '';
        },

        ChangeFilter(m){      
            this.modelFilter = m;
        },

        SearchItems() {
            ePharmacyItemsReceivedService
                .getAvailableForRelocation(this.parameters)
                .then((response) => {
                    if(response.status == '200' && response.data){
                       
                         let data = response.data;

                        data.forEach(element => {
                           element.expirationDateItemRelocation = element.expirationDate; 
                        });
                        this.items = data;

                        let header = JSON.parse(response.headers["x-pagination"]);
                        this.totalRows = header.TotalCount;
                        this.showMessageIsEmpty = this.items.length === 0;
                    }
                    this.SearchItemsTotals();
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        SearchItemsTotals() {
            ePharmacyItemsReceivedService
                .getTotalsAvailableForRelocation(this.parameters)
                .then((response) => {
                    if(response.status == '200'){
                        const totals = response.data || {filled: 0, received: 0, available: 0};

                        this.viewText = `${this.$t('Shared.SearchResult')} - ` +
                            `${this.$t('DrugOrderItemsRemoval.Filled')}: ${totals.filled} - ` +
                            `${this.$t('DrugOrderItemsRemoval.Received')}: ${totals.received} - ` +
                            `${this.$t('DrugOrderItemsRemoval.Available')}: ${totals.available}`
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
            
        },

        getPharmacyLocations() {
            this.pharmacyLocations = [];
            ePharmacyItemsLocationService
                .getAllForRelocation()
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.pharmacyLocations = response.data.map(element => {
                            return {code: element.code.trim(), name: element.name.trim()}
                        }); 
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });

        },

        initialize() {
            Promise.all([this.getPharmacyLocations()]);
        },

        pageChanged(page) {
            this.parameters.PageNumber = page;
            this.SearchItems()
        },
        
        perPageFunction(perPage) {
            this.parameters.PageNumber = 1;
            this.parameters.PageSize = perPage;
            this.SearchItems()
        },

        onRowSelected() {

        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.parameters.PageNumber = 1
        },

        getLocationNameByCode(code){  
            for(var i = 0; i < this.pharmacyLocations.length; i++){
                if(this.pharmacyLocations[i].code === code){
                    return this.pharmacyLocations[i].name;
                }
            }

            return "";
        },

        editHandler(value) {          
            this.editableIndex = this.items.findIndex(item => item === value);
            this.editableItem = value;
            this.editableItem.expirationDate = Utils.formatterDateToString(this.editableItem.expirationDate);  
            this.editableItem.locationName = this.getLocationNameByCode(value.location);
            this.editableItem['locationTo'] = null;
            this.visibleEditDialog = true;
        },

        okHandler() {
            this.visibleEditDialog = false;
            this.goProcess();
        },

        closeHandler() {
            this.visibleEditDialog = false;
        },

        ShowReport() {
            this.isItemReloReportVisible = true
        },

        closeItemReloReportWindow() {
            this.isItemReloReportVisible = false
        },

    },

    async mounted() {
        await this.initialize();
        this.SearchItems();
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;    
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
        case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
    },
}
</script>